import { fromJS } from "immutable"

const isObj = v => 'object' === typeof v && !Array.isArray(v) && v !== null

const getDeepCopy = data => data ? fromJS(data).toJS() : false

const sanitizeFormData = (data, currentValue, setValue, cliCinemas) => {
    const cliCinemasLength = cliCinemas ? _.keys(cliCinemas).length : null

    Object.entries(data).forEach(([key, value]) => {
        if(currentValue === value) {
            if(cliCinemasLength === 1 && key === 'cinemasFilter') {
                data[key] = _.keys(cliCinemas)
            } else {
                data[key] = setValue
            }
        } else if(isObj(value)) {
            sanitizeFormData(data[key], currentValue, setValue)
        } else if(Array.isArray(value) ) {
            value.map(val => sanitizeFormData(val, currentValue, setValue))
        }
    })

    return data
}



export const sanitizeFormInput = (data, cliCinemas=null) => sanitizeFormData(getDeepCopy(data), null, '', cliCinemas)

export const sanitizeFormOutput = (data, cliCinemas=null) => sanitizeFormData(getDeepCopy(data), '', null, cliCinemas)